import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { WishlistProvider } from '@/account/context/wishlist/index';
import WishlistGuestApp from '@/wishlist-guest/WishlistGuestApp';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('js-r-entry-wishlist-guest');
  // load specific namespace for store finder section
  i18n.loadNamespaces(['wishlist'], () => {
    ReactDOM.render(
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <WishlistProvider>
            <WishlistGuestApp {...el.dataset} />
          </WishlistProvider>
        </Suspense>
      </I18nextProvider>,
      el,
    );
  });
});
